import { postRequest } from '../axios';
import { AUTH_KEY } from '../axios/config';
import {
  DesignOption,
  DesktopViewOption,
  DisplayMode,
  DisplayPositionOption,
  HeaderDisplayOption,
} from '@/v2/components/DesignSetting/types';

export enum AgentVersion {
  Studio = 'studio',
  NonStudio = 'non_studio',
}

export interface IFile {
  name: string | null;
  url: string | null;
  size: number | null;
}

export enum AvatarTypeOptions {
  THEME = 'theme',
  MALE = 'male',
  FEMALE = 'female',
  CUSTOM = 'custom',
}

export enum AvatarThemeOptions {
  BLUE = 'blue',
  GREEN = 'green',
  LIGHT_GREEN = 'light_green',
  ORANGE = 'orange',
  PURPLE = 'purple',
  RED = 'red',
  YELLOW = 'yellow',
}

export interface IAgent {
  version?: AgentVersion;
  /** Basic agent information */
  agent_id: string;
  agent_name: string;
  email: string;
  description: string;
  created_at: string;
  chat_settings_id: string;

  /** Design settings */
  dark_mode: boolean;
  theme_color: string;
  font_family: string;
  button_theme: string | null;
  image_url?: string | null;

  /** Display mode & layout */
  display_mode: DisplayMode;
  header_display_option: HeaderDisplayOption;
  header_image?: IFile | null;
  background_pc?: IFile | null;
  background_sp?: IFile | null;
  desktop_view_option: DesktopViewOption;
  character_position: number;
  talking_character_position: number;
  talking_character_size: number;

  /** LINE integration */
  line_client_id: string | null;
  line_client_secret: string;
  line_return_uri: string;
  line_channel_link_flag: boolean;
  line_channel_secret: string;
  line_channel_token: string;

  /** Chat settings */
  chat_login_flag: boolean;
  voice_mode_flag: boolean;
  voice_mode_greeting: string | null;
  remaining_conversation: number | null;
  additional_conversation: number | null;
  voice_id: string;
  quick_reply_messages: string[];
  first_fixed_message: string;
  model_streaming: boolean;
  use_form: boolean;
  faq_flag: boolean;
  max_conversation: number;

  /** Waiting design */
  design_option: DesignOption;
  banner_pc: IFile;
  banner_sp: IFile;
  display_position_option: DisplayPositionOption;

  /** Emotion */
  avatar_type: AvatarTypeOptions;
  avatar_theme: AvatarThemeOptions;
}

export const getAgent = async () => {
  const auth = JSON.parse(localStorage.getItem(AUTH_KEY) || '{}');

  if (!auth?.agent_id) {
    throw new Error('担当者情報を取得できませんでした。もう一度お試しください。');
  }

  const response = await postRequest<IAgent, { agent_id: string }>(
    `/get-agent`,
    { agent_id: auth.agent_id },
  );
  return response;
};
